import React from 'react';
import propTypes from 'prop-types';

import { Button, ButtonDropdown } from '@tcc/crate';

const ToolbarButton = ({text, onClick, disabled, isChild, children, testId}) => {
  const isSubmenu = (children && children.length > 0);
  let button = null;
  if (isSubmenu) {
    button = (<ButtonDropdown
      className='vra-map-toolbar__submenu'
      disabled={ disabled }
      mode='map'
      onClick={ onClick } 
      testId='vra-map-toolbar__submenu'
      title={ text }>{ children }</ButtonDropdown>);
  } else {
    const mode = isChild ? 'link' : 'map';
    button = (<Button
      className='vra-map-toolbar__button'
      disabled={ disabled }
      mode={ mode }
      onClick={ onClick }
      testId={`${testId}-button`}>{ text }</Button>);
  }

  const className = (isChild)
    ? 'vra-map-toolbar__button-outer-child' : 'vra-map-toolbar__button-outer';
  return (
    <div className={ className } data-test-id={testId}>
      { button }
    </div>
  );
};

ToolbarButton.propTypes = {
  children: propTypes.node,
  disabled: propTypes.bool,
  isChild:  propTypes.bool,
  onClick:  propTypes.func,
  testId:   propTypes.string,
  text:     propTypes.string
};

export default ToolbarButton;
